import * as React from "react";
import { useNavigate } from "@reach/router";

import { Placeholder } from "kanopi-components/Placeholder";
import { useActivePolicy } from "../hooks/useActivePolicy";

export function ActivePolicyPage() {
  const { activePolicyId, loading } = useActivePolicy();
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!loading && activePolicyId) {
      navigate(`/policies/${activePolicyId}`);
    }
  }, [activePolicyId, loading]);
  return <Placeholder loading={loading} />;
}
